module.exports = __webpack_public_path__ + "static/img/medal-illness.779929b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medal-illness.png
// module id = eTld
// module chunks = 9